// location: Value between 0-4: Account setting page : 0, Campaign page: 1, Top : 2, Area top : 3, Booking Step: 4
export const SUBSCRIPTION_LOCATION = {
  ACCOUNT_SETTING: 0,
  CAMPAIGN: 1,
  TOP: 2,
  AREA_TOP: 3,
  BOOKING_STEP_2: 4,
};
